import { FaSpinner } from 'react-icons/fa';
import styled, { keyframes, Keyframes } from 'styled-components';

const spinnerAnimation: Keyframes = keyframes`
     0% { transform: rotate(0deg);}
     100% { transform: rotate(359deg);}
`;

export const Spinner = styled(FaSpinner)`
  height: 25px;
  width: 25px;
  color: white;
  margin: auto;
  animation: ${spinnerAnimation} 1.5s infinite linear;
`;
